module.exports = __webpack_public_path__ + "img/05_kudo_11.826cbc24.jpg";